<template>
  	<AddSingleDnss />
</template>

<script>

// @ is an alias to /src
import AddSingleDnss from "../components/AddSingleDns.vue";

export default {
  name: "AddSingleDns",
  components: {
    AddSingleDnss,
  },
};
</script>
